import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

import DocPage from "../components/DocPage.vue";
import { company } from "../company";


export default /*#__PURE__*/_defineComponent({
  __name: 'Privacy',
  setup(__props) {

const sections = [
  { key: "collect", paras: 2 },
  { key: "why", paras: 1 },
  { key: "keep", paras: 1 },
  { key: "cookies", paras: 1 },
  { key: "thirdparty", paras: 1 },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DocPage, {
    title: _ctx.$t('pages.privacy.title'),
    lede: _ctx.$t('pages.privacy.lede'),
    updated: _ctx.$t('pages.updated', { date: _unref(company).privacyUpdated })
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.privacy.controller.title")), 1),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t("pages.privacy.controller.p1", { name: _unref(company).legalName })) + " ", 1),
        _createElementVNode("a", {
          href: `mailto:${_unref(company).email}`
        }, _toDisplayString(_unref(company).email), 9, _hoisted_1)
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (s) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: s.key
        }, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(`pages.privacy.${s.key}.title`)), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.paras, (n) => {
            return (_openBlock(), _createElementBlock("p", { key: n }, _toDisplayString(_ctx.$t(`pages.privacy.${s.key}.p${n}`)), 1))
          }), 128))
        ], 64))
      }), 64)),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.privacy.rights.title")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.privacy.rights.p1")), 1),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t("pages.privacy.rights.p2")) + " ", 1),
        _createElementVNode("a", {
          href: `mailto:${_unref(company).email}?subject=Personal%20data`
        }, _toDisplayString(_unref(company).email), 9, _hoisted_2)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.privacy.rights.p3")), 1)
    ]),
    _: 1
  }, 8, ["title", "lede", "updated"]))
}
}

})